import React from 'react'
import { Col, Row } from 'react-bootstrap'

import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'
import PlatformMobile from '@assets/images/platfor-mobile.png'
import PlatformMobileResposnive from '@assets/images/platformMobileResponsive.svg'
import PlatformShape from '@assets/images/shape1.png'

function AcrossPlatforms() {
  const handleScroll = (e) => {
    e.preventDefault()
    const targetSection = document.getElementById('contact-us')

    if (targetSection) {
      const targetPosition = targetSection.getBoundingClientRect().top + window.scrollY - 250
      window.scrollTo({ top: targetPosition, behavior: 'smooth' })
    }
  }

  return (
    <div className={`${styles.acrossPlatforms} position-relative`}>
      <MyImage className={`${styles.platformshape}`} src={PlatformShape} alt="platform" />
      <Row className="position-relative z-index-1 g-0 g-md-4">
        <Col className={`${styles.acrossPlatformsleft} col-6`}>
          <h2 className={`${styles.acrossPlatformsTitle}`}>
            Connect with Our <strong>Vibrant Community</strong> Across Platforms
          </h2>
          <a href="#contact-us" className="theme-btn" onClick={handleScroll}>
            Contact now
          </a>
        </Col>
        <Col className={`${styles.acrossPlatformsImage} col-6`}>
          <MyImage src={PlatformMobile} alt="platform" />
          <MyImage src={PlatformMobileResposnive} alt="platform" />
        </Col>
      </Row>
    </div>
  )
}

export default AcrossPlatforms
